var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "35px",
    viewBox: "0 0 38 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1293.000000, -782.000000)",
    fill: "#989898",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1225.000000, 782.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(68.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2559524,6 L7.74404762,6 C7.33311012,6 7,5.664225 7,5.25 L7,3.3 C7,1.477425 8.4656994,0 10.2738095,0 L28.7261905,0 C30.5343006,0 32,1.477425 32,3.3 L32,5.25 C32,5.664225 31.6668899,6 31.2559524,6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9921875,9 L4.0078125,9 C1.797875,9 0,10.8004324 0,13.0135135 L0,26.9864865 C0,29.1995676 1.797875,31 4.0078125,31 L6.53125,31 L6.53125,25.0540541 C6.53125,22.1033041 8.92844141,19.7027027 11.875,19.7027027 L26.125,19.7027027 C29.0715586,19.7027027 31.46875,22.1033041 31.46875,25.0540541 L31.46875,31 L33.9921875,31 C36.202125,31 38,29.1995676 38,26.9864865 L38,13.0135135 C38,10.8004324 36.202125,9 33.9921875,9 Z M7.12648437,17.9189189 C6.14271484,17.9189189 5.34486328,17.1203041 5.34486328,16.1351351 C5.34486328,15.1499662 6.14197266,14.3513514 7.12574219,14.3513514 L7.12648438,14.3513514 C8.11025391,14.3513514 8.90773438,15.1499662 8.90773438,16.1351351 C8.90773438,17.1203041 8.11025391,17.9189189 7.12648438,17.9189189 L7.12648437,17.9189189 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,23 L11.8,23 C10.805875,23 10,23.805875 10,24.8 L10,30.8 L10,33.2 C10,34.194125 10.805875,35 11.8,35 L26.2,35 C27.194125,35 28,34.194125 28,33.2 L28,30.8 L28,24.8 C28,23.805875 27.194125,23 26.2,23 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.92b9d62a64da6250d93b74e8e8719db8.svg";
export { ForwardRef as ReactComponent };